export default "__VITE_ASSET__3ed3e7c7__"